import React from 'react';
import ImportIcon from '@mui/icons-material/MoveToInbox';

import { userCanAccessProjectsClient } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { startImportComponent } from '../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuItem } from '../common/SceneMenuItem';

export function ImportComponentDesignMenuItem() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const context = useAppSelector((state) => state.application.openContext);
  const canAccessProjectClient = useAppSelector(userCanAccessProjectsClient);

  if (context?.type !== 'project' || !canAccessProjectClient) return null;

  return (
    <SceneMenuItem
      icon={<ImportIcon />}
      text="Import Component Design"
      onClick={() => {
        dispatch(startImportComponent({ parentGuid: context.projectGuid }));
        monitor.recordInteraction('Import Component menu item clicked');
      }}
    />
  );
}
